import { createSlice } from "@reduxjs/toolkit";
import { years, months } from "../../secretary/data";

const initialState = {
  proceduresParent: {
    data: [],
    isLoading: false,
    error: null,
  },
  procedures: {
    data: [],
    isLoading: false,
    error: null,
  },
  years: {
    data: years,
    isLoading: false,
    error: null,
  },
  satisfactionQuestions: {
    data: [],
    isLoading: false,
    error: null,
  },
  months: {
    data: months,
    isLoading: false,
    error: null,
  },
};

export const selectOptionsSlice = createSlice({
  name: "selectOptions",
  initialState,
  reducers: {
    setSelectOptions(state, { payload }) {
      const { key, data } = payload;
      if (state[key]) {
        state[key] = {
          data,
          isLoading: false,
          error: null,
        };
      }
    },
    setSelectLoading(state, { payload }) {
      const { key } = payload;
      if (state[key]) {
        state[key].isLoading = true;
        state[key].error = null;
      }
    },
    setSelectError(state, { payload }) {
      const { key, error } = payload;
      if (state[key]) {
        state[key] = {
          ...state[key],
          isLoading: false,
          error,
        };
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSelectOptions, setSelectLoading, setSelectError } =
  selectOptionsSlice.actions;
